import type { FlattenedSectionProps } from "../../../../components/Questionnaire/Section";
import type { QuestionnaireState } from "../../types";

export const handleShowQuestionAction = (
  state: QuestionnaireState,
  payload: string, // question name
): QuestionnaireState => {
  const { sections: sectionsFromState, currentSectionIndex } = state;
  const sections = sectionsFromState as unknown as FlattenedSectionProps[];
  const sectionIndex = sections.findIndex(({ questions }) =>
    questions.some(q => q.name === payload),
  );

  return {
    ...state,
    currentSectionIndex:
      sectionIndex !== -1 ? sectionIndex : currentSectionIndex,
    selectedQuestion: payload,
    changedQuestions: [],
  };
};
